import { AxiosService } from './axiosService';

export class ProposalService extends AxiosService {
    async getProposals(pageSize, pageIndex, sortField, sortDirection) {
        try {
            const { data } = await this.axios.get('/proposals', {
                params: {
                    pageSize: pageSize,
                    pageIndex: pageIndex,
                    sortBy: sortField,
                    orderBy: sortDirection
                },
            });
            return data;
        } catch (e) {
            // if the status code is a 401 we do NOT want to throw
            if (e?.response?.status !== 401) {
                throw e;
            }
        }
        return null;
    }

    async acceptProposal(viewToken) {
        try {
            const { data } = await this.axios.post(`/proposals/approve/${viewToken}`, {});
            return data;
        } catch (e) {
            // if the status code is a 401 we do NOT want to throw
            if (e?.response?.status !== 401) {
                throw e;
            }
        }
        return null;
    }

    async postProposal(customerId, proposalItems, opening, termsAndConditions, name) {
        try {
            const { data } = await this.axios.post('/proposals', {
                customerId: customerId.toString(),
                proposalItems,
                opening,
                termsAndConditions,
                name
            });
            return data;
        } catch (e) {
            // if the status code is a 401 we do NOT want to throw
            if (e?.response?.status !== 401) {
                throw e;
            }
        }
        return null;
    }

    async editProposal(proposalId, proposalItems, opening, termsAndConditions, name) {
        try {
            const { data } = await this.axios.put(`/proposals`, {
                id: proposalId,
                items: proposalItems,
                opening,
                termsAndConditions,
                name
            });
            return data;
        } catch (e) {
            // if the status code is a 401 we do NOT want to throw
            if (e?.response?.status !== 401) {
                throw e;
            }
        }
        return null;
    }

    async getProposalById(id) {
        try {
            const { data } = await this.axios.get(`/proposals/${id}`);
            return data;
        } catch (e) {
            // if the status code is a 401 we do NOT want to throw
            if (e?.response?.status !== 401) {
                throw e;
            }
        }
        return null;
    }

    async getProposalByViewToken(viewToken) {
        try {
            const { data } = await this.axios.get(`/proposals/view/${viewToken}`);
            return data;
        } catch (e) {
            // if the status code is a 401 we do NOT want to throw
            if (e?.response?.status !== 401) {
                throw e;
            }
        }
        return null;
    }

    async sendProposalEmail(id) {
        try {
            const { data } = await this.axios.post('/proposals/email', {
                proposalId: id,
            });
            return data;
        } catch (e) {
            // if the status code is a 401 we do NOT want to throw
            if (e?.response?.status !== 401) {
                throw e;
            }
        }
        return null;
    }

    async updateEnvelopeStatus(envelopeId, status) {
        try {
            const { data } = await this.axios.post('/envelopes/updateStatus', {
                envelopeId,
                status
            });
            return data;
        } catch (e) {
            // if the status code is a 401 we do NOT want to throw
            if (e?.response?.status !== 401) {
                throw e;
            }
        }
        return null;
    }

    async downloadProposal(id) {
        try {
            const { data } = await this.axios.get(`/proposals/download/${id}`, {
                responseType: "blob"
            });

            const blob = new Blob([data], { type: 'application/pdf' });
            const url = window.URL.createObjectURL(blob)

            window.open(url)
        } catch (e) {
            // if the status code is a 401 we do NOT want to throw
            if (e?.response?.status !== 401) {
                throw e;
            }
        }
        return null;
    }

    async deleteProposal(id) {
        try {
            const { data } = await this.axios.delete(`/proposals/${id}`, {
                data: {
                    id
                }
            });
            return data;
        } catch (e) {
            // if the status code is a 401 we do NOT want to throw
            if (e?.response?.status !== 401) {
                throw e;
            }
        }
        return null;
    }
}

export const proposalService = new ProposalService();
